<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sidemenu.memberFilter.title") }}</h1>
    <searchCom ref="searchComRef" :isHideCategory="true" :isHideDate="true" @filter="filter_fn" @create="create_fn" />
    <!-- Table -->
    <el-table
      :data="tableData"
      class="egl-table list-table"
      stripe
    >
      <el-table-column
        :label="$locale('global.name')"
        prop="name"
        width="200"
        align="center"
        >
      </el-table-column>
      <el-table-column
        :label="$locale('theatre.description')"
        prop="describe"
        >
      </el-table-column>
      <el-table-column
        :label="$locale('membership.detail.form.condition')"
        prop="condition"
        :formatter="conditionFormatter"
        >
      </el-table-column>
      <el-table-column align="center" width="160">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="export_fn(scope.row.id)">{{ $locale('memberFilter.list.export') }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="showDetail(scope.row.id)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id, scope.row.name)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      v-show="pageCount > 10"
      :total="pageCount"
      :curPage="page"
      :pageSize="pageSize"
      @current-change="choosePage"
    />
  </div>
</template>
<script>
import searchCom from "../MailMagazine/searchCom";
import CommPagination from "@/components/common/CommPagination";

import countDownAlert from "@/utils/countDownAlert";
import { ageGroup } from "@/assets/js/sendCoupon";
import { getMemberGender } from "@/assets/js/membership";
import { getRankListForMemberShipIds } from "@/utils/common";

import { getMailingListService, deleteMailingService, exportMembersService } from "@/helpers/service/api/memberFilter";
import { getCinemaListMap, getSimpleMovieList } from "@/helpers/service/api/common";
import { getMemberShipListService } from "@/helpers/service/api/membership";

export default {
  data() {
    return {
      tableData: [],
      cinemaList: [],
      membershipList: [],
      movieList: [],
      page: 0,
      pageSize: 10,
      pageCount: 1,
    };
  },
  created() {
    getMailingListService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.tableData = res.data.data;
        let movieIds = [];
        res.data.data.forEach(item => {
          // 确保movieId是数组后再遍历
          const safeMovieId = Array.isArray(item.movieId) ? item.movieId : [];
          safeMovieId.forEach(id => {
            movieIds.push(id);
          });
        });
        if (this.$_.uniq(movieIds).length > 0) {
          getSimpleMovieList({
            brandId: window.localStorage.getItem("brandId"),
            ids: movieIds,
            page: 0,
            pageSize: 20,
            hiddenCms: false,
            status: "active",
            approve: true,
            field: ["id", "name"],
          }).then(res => {
            if (res.data && res.data.data && res.data.data.length > 0) {
              this.movieList = res.data.data;
            }
          });
        }
      } else {
        this.tableData = [];
      }
      this.pageCount = res.data.count;
    });
    getCinemaListMap({ brandId: window.localStorage.getItem("brandId"), field: ["id", "name"], page: 0, pageSize: 99999 }).then(res => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.cinemaList = res.data.data;
      }
    });
    getMemberShipListService({ brandId: window.localStorage.getItem("brandId"), page: 0, pageSize: 99999 }).then(res => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.membershipList = res.data.data;
        // this.getMemberRankList(this.form.membershipId, this.membershipList);
      }
    });
  },
  methods: {
    filter_fn(onSearch = {}, page = 1, isFilter = true) {
      if (isFilter) {
        this.page = 0;
      }
      getMailingListService({
        brandId: window.localStorage.getItem("brandId"),
        ...onSearch,
        page: page - 1,
        pageSize: 10,
      }).then(res => {
        this.pageCount = res.data.count;
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.tableData = res.data.data;
        } else {
          this.tableData = [];
        }
      });
    },
    create_fn() {
      this.$router.push("/member-filter/create");
    },
    export_fn(id) {
      exportMembersService(id).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([bom, content], { type: "text/csv;charset=utf-8;" });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = "会員リスト.csv";
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    showDetail(id) {
      this.$router.push(`/member-filter/update/${id}`);
    },
    delete_fn(id, name) {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          deleteMailingService({ id }).then(res => {
            if (!res.success) { return; }
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.filter_fn(this.$refs.searchComRef.searchObj, this.page);
              }
            });
          });
        });
    },
    conditionFormatter(row) {
      // 安全解构，设置默认值
      const {
        startTime,
        endTime,
        age = [],
        gender = [],
        prefecture = [],
        favoriteCinemaId = [],
        favoriteGenres = [],
        membershipId = [],
        membershipRankId = [],
        movieId = [],
        timeCheck,
        ageCheck,
        genderCheck,
        addressCheck,
        favoriteCinemaCheck,
        favoriteGenreCheck,
        membershipCheck,
        membershipRankCheck,
        movieCheck,
      } = row || {};

      // 确保解构出的属性都是数组
      const safeAge = Array.isArray(age) ? age : [];
      const safeGender = Array.isArray(gender) ? gender : [];
      const safePrefecture = Array.isArray(prefecture) ? prefecture : [];
      const safeFavoriteCinemaId = Array.isArray(favoriteCinemaId) ? favoriteCinemaId : [];
      const safeFavoriteGenres = Array.isArray(favoriteGenres) ? favoriteGenres : [];
      const safeMembershipId = Array.isArray(membershipId) ? membershipId : [];
      const safeMembershipRankId = Array.isArray(membershipRankId) ? membershipRankId : [];
      const safeMovieId = Array.isArray(movieId) ? movieId : [];

      // 勾选 + 空数组（保存时「全て」会转成 []）→ 列表显示「全て」
      // onlyForAll: 仅对有「全て」选项的字段（年齢/会員種類/ランク）在空数组时显示「全て」
      const formatCheckedList = (checked, list, label, mapFn, onlyForAll = false) => {
        if (!checked) return "";
        if (!list.length) {
          return onlyForAll ? `${label}：全て` : "";
        }
        return `${label}：${list.map(mapFn).join("、")}`;
      };

      const timePart = timeCheck && startTime && endTime ?
        `加入日付：${this.$moment(startTime).format("YYYY-MM-DD HH:mm")} ~ ${this.$moment(endTime).format("YYYY-MM-DD HH:mm")}` :
        "";

      const agePart = formatCheckedList(
        ageCheck,
        safeAge,
        "年齢層",
        value => ageGroup[value] || value,
        true
      );

      const genderPart = formatCheckedList(
        genderCheck,
        safeGender,
        "性別",
        value => {
          const genderItem = getMemberGender().find(item => item.value === value);
          return genderItem ? genderItem.label : value;
        }
      );

      const addressPart = formatCheckedList(
        addressCheck,
        safePrefecture,
        "都道府県",
        value => value
      );

      const cinemaPart = formatCheckedList(
        favoriteCinemaCheck && this.cinemaList.length > 0,
        safeFavoriteCinemaId,
        "お気に入り劇場",
        cinemaId => {
          const cinema = this.cinemaList.find(cinema => cinema.id === cinemaId);
          return cinema ? cinema.name : cinemaId;
        }
      );

      const genrePart = formatCheckedList(
        favoriteGenreCheck,
        safeFavoriteGenres,
        "好きなジャンル",
        value => value
      );

      const memberShipPart = formatCheckedList(
        membershipCheck && this.membershipList.length > 0,
        safeMembershipId,
        "会員種類",
        id => {
          const membership = this.membershipList.find(item => item.id === id);
          return membership ? membership.name : id;
        },
        true
      );

      // membershipId 为空（全て）时，用全部 membership 去 mapping rank 名字
      const membershipIdsForRank = safeMembershipId.length === 0
        ? this.membershipList.map(item => item.id)
        : safeMembershipId;

      const memberRankPart = formatCheckedList(
        membershipRankCheck && this.membershipList.length > 0,
        safeMembershipRankId,
        "ランク",
        id => {
          const rankList = getRankListForMemberShipIds(membershipIdsForRank, this.membershipList);
          if (!rankList || !Array.isArray(rankList)) {
            return id;
          }
          const rank = rankList.find(item => item.uuid === id);
          return rank ? rank.name : id;
        },
        true
      );

      const moviePart = formatCheckedList(
        movieCheck && this.movieList.length > 0,
        safeMovieId,
        "観た映画",
        id => {
          const movie = this.movieList.find(item => item.id === id);
          return movie ? movie.name : id;
        }
      );

      // 合并格式化结果，空格隔开
      return [
        timePart,
        agePart,
        genderPart,
        addressPart,
        cinemaPart,
        genrePart,
        memberShipPart,
        memberRankPart,
        moviePart,
      ].filter(Boolean).join(" ");
    },
    choosePage(page) {
      this.page = page - 1;
      this.filter_fn(this.$refs.searchComRef.searchObj, page, false);
    },
  },
  components: {
    searchCom,
    CommPagination,
  },
};
</script>